import { enumTransportationMode } from '@app/data-layer/enums/entry-summaries';
import { IBillOfLadingFormData } from '@app/modules/entry-summary/interfaces';
import { INPUT_TYPES_MAP } from '@constants/input-types-map';

export const esBlFormData: { [key: string]: IBillOfLadingFormData } = {
  [enumTransportationMode.OCEAN]: {
    title: 'ENTRY_SUMMARY.BILL_OF_LADING',
    subTitle: 'INFO.BL.SUB_TITLE_OCEAN',
    carrier: {
      titleMaster: 'FORM_LABEL.MASTER_CARRIER',
      titleHouse: 'FORM_LABEL.HOUSE_CARRIER',
      placeholder: 'FORM_PLACEHOLDER.CARRIER',
      helper: 'FORM_HELPER.CARRIER_DESKTOP',
      maskMaster: 'S{4}',
      maskHouse: 'S{4}',
      inputmodeMaster: 'text',
      inputmodeHouse: 'text',
      patternMaster: '',
      patternHouse: '',
      maskMessageMaster: 'MASK_ERROR.ONLY_ENGLISH',
      maskMessageHouse: 'MASK_ERROR.ONLY_ENGLISH',
      maxMaskLength: 4,
      tooltip: 'INFO.BL.SUB_TITLE_SCAC_OCEAN_DESKTOP',
    },
    number: {
      titleMaster: 'FORM_LABEL.MASTER_BL',
      titleHouse: 'FORM_LABEL.HOUSE_BL',
      placeholder: 'FORM_PLACEHOLDER.BILL_NUMBER',
      helper: 'FORM_HELPER.BILL_NUMBER_DESKTOP',
      maskMaster: 'A{12}',
      maskHouse: 'A{12}',
      inputmodeMaster: 'text',
      inputmodeHouse: 'text',
      patternMaster: '',
      patternHouse: '',
      maskMessageMaster: 'MASK_ERROR.ONLY_ENGLISH_DIGITS',
      maskMessageHouse: 'MASK_ERROR.ONLY_ENGLISH_DIGITS',
      maxMaskLength: 12,
      tooltip: 'INFO.BL.SUB_TITLE_BL_OCEAN_DESKTOP',
    },
    packages: {
      title: 'INFO.BL.TITLE_PACKAGES',
    },
  },
  [enumTransportationMode.AIR]: {
    title: 'FORM_LABEL.AIRWAY_BILL',
    subTitle: 'INFO.BL.SUB_TITLE_AIR',
    carrier: {
      titleMaster: 'FORM_LABEL.MASTER_AIRWAY_BILL_PREFIX',
      titleHouse: 'FORM_LABEL.HOUSE_AIRWAY_BILL_PREFIX',
      placeholder: 'FORM_PLACEHOLDER.DIGITS_AIRLINE_PREFIX',
      helper: 'FORM_PLACEHOLDER.DIGITS_AIRLINE_PREFIX',
      maskMaster: '0{3}',
      maskHouse: 'A{3}',
      inputmodeMaster: 'decimal',
      inputmodeHouse: 'text',
      patternMaster: INPUT_TYPES_MAP.INTEGER.pattern,
      patternHouse: '',
      maskMessageMaster: 'MASK_ERROR.ONLY_DIGITS',
      maskMessageHouse: 'MASK_ERROR.ONLY_ENGLISH_DIGITS',
      maxMaskLength: 3,
      tooltip: 'INFO.BL.SUB_TITLE_SCAC_AIR_DESKTOP',
    },
    number: {
      titleMaster: 'FORM_LABEL.MASTER_AIRWAY_BILL_NUMBER',
      titleHouse: 'FORM_LABEL.HOUSE_AIRWAY_BILL_NUMBER',
      placeholder: 'FORM_PLACEHOLDER.DIGITS_AIRLINE_NUMBER',
      helper: 'FORM_PLACEHOLDER.DIGITS_AIRLINE_NUMBER',
      maskMaster: '0{9}',
      maskHouse: 'A{9}',
      inputmodeMaster: 'decimal',
      inputmodeHouse: 'text',
      patternMaster: INPUT_TYPES_MAP.INTEGER.pattern,
      patternHouse: '',
      maskMessageMaster: 'MASK_ERROR.ONLY_DIGITS',
      maskMessageHouse: 'MASK_ERROR.ONLY_ENGLISH_DIGITS',
      maxMaskLength: 9,
      tooltip: 'INFO.BL.SUB_TITLE_BL_AIR_DESKTOP',
    },
    packages: {
      title: 'INFO.BL.TITLE_PACKAGES',
    },
  },
  [enumTransportationMode.RAIL]: {
    title: 'ENTRY_SUMMARY.BILL_OF_LADING',
    subTitle: 'INFO.BL.SUB_TITLE_RAIL',
    carrier: {
      titleMaster: 'FORM_LABEL.MASTER_CARRIER',
      titleHouse: '',
      placeholder: 'FORM_PLACEHOLDER.CARRIER',
      helper: 'FORM_HELPER.CARRIER_DESKTOP',
      maskMaster: 'S{4}',
      maskHouse: 'S{4}',
      inputmodeMaster: 'text',
      inputmodeHouse: 'text',
      patternMaster: '',
      patternHouse: '',
      maskMessageMaster: 'MASK_ERROR.ONLY_ENGLISH',
      maskMessageHouse: 'MASK_ERROR.ONLY_ENGLISH',
      maxMaskLength: 4,
      tooltip: 'INFO.BL.SUB_TITLE_SCAC_RAIL_DESKTOP',
    },
    number: {
      titleMaster: 'FORM_LABEL.MASTER_BL',
      titleHouse: '',
      placeholder: 'FORM_PLACEHOLDER.BILL_NUMBER',
      helper: 'FORM_HELPER.BILL_NUMBER_DESKTOP',
      maskMaster: 'A{12}',
      maskHouse: 'A{12}',
      inputmodeMaster: 'text',
      inputmodeHouse: 'text',
      patternMaster: '',
      patternHouse: '',
      maskMessageMaster: 'MASK_ERROR.ONLY_ENGLISH_DIGITS',
      maskMessageHouse: 'MASK_ERROR.ONLY_ENGLISH_DIGITS',
      maxMaskLength: 12,
      tooltip: 'INFO.BL.SUB_TITLE_BL_OCEAN_DESKTOP',
    },
    packages: {
      title: 'INFO.BL.TITLE_PACKAGES',
    },
  },
  default: {
    title: 'ENTRY_SUMMARY.BILL_OF_LADING',
    subTitle: 'INFO.BL.SUB_TITLE_OCEAN',
    carrier: {
      titleMaster: 'FORM_LABEL.MASTER_CARRIER',
      titleHouse: 'FORM_LABEL.HOUSE_CARRIER',
      placeholder: 'FORM_PLACEHOLDER.CARRIER',
      helper: 'FORM_HELPER.CARRIER_DESKTOP',
      maskMaster: 'S{4}',
      maskHouse: 'S{4}',
      inputmodeMaster: 'text',
      inputmodeHouse: 'text',
      patternMaster: '',
      patternHouse: '',
      maskMessageMaster: 'MASK_ERROR.ONLY_ENGLISH',
      maskMessageHouse: 'MASK_ERROR.ONLY_ENGLISH',
      maxMaskLength: 4,
      tooltip: 'INFO.BL.SUB_TITLE_SCAC_OCEAN_DESKTOP',
    },
    number: {
      titleMaster: 'FORM_LABEL.MASTER_BL',
      titleHouse: 'FORM_LABEL.HOUSE_BL',
      placeholder: 'FORM_PLACEHOLDER.BILL_NUMBER',
      helper: 'FORM_HELPER.BILL_NUMBER_DESKTOP',
      maskMaster: 'A{12}',
      maskHouse: 'A{12}',
      inputmodeMaster: 'text',
      inputmodeHouse: 'text',
      patternMaster: '',
      patternHouse: '',
      maskMessageMaster: 'MASK_ERROR.ONLY_ENGLISH_DIGITS',
      maskMessageHouse: 'MASK_ERROR.ONLY_ENGLISH_DIGITS',
      maxMaskLength: 12,
      tooltip: 'INFO.BL.SUB_TITLE_BL_OCEAN_DESKTOP',
    },
    packages: {
      title: 'INFO.BL.TITLE_PACKAGES',
    },
  },
};
